module.exports = __webpack_public_path__ + "img/kefalet-sigortasi.a88ca4f9.svg";